import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/debounceTime';

import { CompanyRoutingModule } from './company.routes';
import { CompanyPartnershipComponent } from './company-partnership/company-partnership.component';
import { CompanyPartnershipDetailComponent } from './company-partnership-detail/company-partnership-detail.component';
import { ColabsManagerComponent } from './colabs-manager/colabs-manager.component';
import { ColabsListingComponent } from './colabs-manager/colabs-listing/colabs-listing.component';
import { ColabsFilterFormComponent } from './colabs-manager/colabs-listing/colabs-filter-form/colabs-filter-form.component';
import { ColabsTableComponent } from './colabs-manager/colabs-listing/colabs-table/colabs-table.component';
import { ColabsRegistrationComponent } from './colabs-manager/colabs-registration/colabs-registration.component';
import { ColabsImportComponent } from './colabs-manager/colabs-import/colabs-import.component';
import { ColabsBlockComponent } from './colabs-manager/colabs-block/colabs-block.component';
import { ColabsAutoUpdateComponent } from './colabs-manager/colabs-autoupdate/colabs-autoupdate.component';
import {
  ColabsModalChangeGroupComponent
} from './colabs-manager/colabs-listing/colabs-modal-change-group/colabs-modal-change-group.component';

import { CompanyDetailComponent } from './company-detail/company-detail.component';
import { InternalRegistrationCompanyComponent } from './internal-registration-company/internal-registration-company.component';
import { AddressesComponent } from './addresses/addresses.component';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { TextMaskModule } from 'angular2-text-mask';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { SelectModule } from 'ng2-select';
import { AccordionModule } from 'ngx-accordion';
import { ModalModule } from '../../components/modal/modal.module';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { TooltipModule } from 'ng2-tooltip-directive';
import { LightboxModule } from 'angular2-lightbox';
import { ShareButtonsModule } from 'ngx-sharebuttons';
import { ComponentsModule } from '../../components/components.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { PipesModule } from 'src/app/pipes/pipes.module';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    CompanyPartnershipComponent,
    CompanyPartnershipDetailComponent,
    ColabsManagerComponent,
    ColabsListingComponent,
    ColabsFilterFormComponent,
    ColabsTableComponent,
    ColabsRegistrationComponent,
    ColabsImportComponent,
    ColabsBlockComponent,
    ColabsAutoUpdateComponent,
    InternalRegistrationCompanyComponent,
    AddressesComponent,
    CompanyDetailComponent,
    ColabsModalChangeGroupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    PipesModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ShareButtonsModule.forRoot(),
    CompanyRoutingModule,
    NgxDatatableModule,
    MultiselectDropdownModule,
    ComponentsModule,
    TextMaskModule,
    DropzoneModule,
    SelectModule,
    AccordionModule,
    ModalModule,
    LeafletModule.forRoot(),
    LightboxModule,
    TooltipModule,
  ],
})

export class CompanyModule {}
